export const ruleEditModal = 'ruleEditModal';
